// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    hasProductsWithInvalidPrice,
    hasRestrictedCartLines,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CustomAppState } from "@keller/App/Store/Reducers";
import { getIsNonPurchasable } from "@keller/App/Store/Selectors/GeneralSelectors";

export const xCanCheckoutWithCart = (state: ApplicationState, cart: Cart | undefined) =>
    cart &&
    (cart.canCheckOut || hasRestrictedCartLines(cart) || hasProductsWithInvalidPrice(cart)) &&
    !getIsNonPurchasable(state) &&
    !(state as CustomAppState).xMaintenance.data?.isDown;
